export default "__VITE_ASSET__CUvFz4$2__"